import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Drawer from 'material-ui/Drawer';
import IconButton from 'material-ui/IconButton';
import List, { ListItem, ListItemText } from 'material-ui/List';
import Divider from 'material-ui/Divider';
import Settings from 'material-ui-icons/Settings';
import Checkbox from 'material-ui/Checkbox';
import Switch from 'material-ui/Switch';
import { SETTINGS_CHARTS_CONNECT_NULLS } from '../../constants/actionMessages';

const styles = {
  capitalize: {
    textTransform: 'capitalize'
  }
};

const chartTypes = ['line', 'area', 'column'];

class NavChartOptions extends Component {
  state = {
    open: {
      right: false
    }
  };

  toggleDrawer = (side, open) => {
    const drawerState = {};
    drawerState[side] = open;
    this.setState({ open: drawerState });
  };

  handleRightOpen = () => this.toggleDrawer('right', true);
  handleRightClose = () => this.toggleDrawer('right', false);

  render() {
    const {
      classes,
      chartOptions,
      setChartConnectNulls,
      setChartType,
      setChartEnergyTypes,
      loading
    } = this.props;
    const filterListItems = chartTypes.map(key => (
      <ListItem key={key} button onClick={() => setChartType(key)}>
        <Checkbox
          checked={chartOptions.chartType === key}
          tabIndex="-1"
          disableRipple
        />
        <ListItemText className={classes.capitalize} primary={[key]} />
      </ListItem>
    ));

    const chartYAxis = Object.keys(chartOptions.energyTypes).map(key => (
      <ListItem key={key} button onClick={() => setChartEnergyTypes(key)}>
        <Checkbox
          checked={chartOptions.activeEnergyTypes.includes(key)}
          tabIndex="-1"
          disableRipple
        />
        <ListItemText
          className={classes.capitalize}
          primary={chartOptions.energyTypes[key].name}
        />
      </ListItem>
    ));

    const additionalChartSettings = (
      <div>
        <ListItem button>
          <Switch
            onClick={event => setChartConnectNulls(!chartOptions.connectNulls)}
            checked={chartOptions.connectNulls}
          />
          <ListItemText primary={SETTINGS_CHARTS_CONNECT_NULLS} />
        </ListItem>
      </div>
    );

    const sideList = (
      <div>
        <List className={classes.list} disablePadding>
          {filterListItems}
        </List>
        <Divider />
        <List className={classes.list} disablePadding>
          {additionalChartSettings}
        </List>
        <Divider />
        <List className={classes.list} disablePadding>
          {chartYAxis}
        </List>
      </div>
    );

    return (
      <div>
        <IconButton disabled={loading} onClick={this.handleRightOpen}>
          <Settings />
        </IconButton>

        <Drawer
          anchor="right"
          open={this.state.open.right}
          onRequestClose={this.handleRightClose}
        >
          {sideList}
        </Drawer>
      </div>
    );
  }
}

NavChartOptions.propTypes = {
  classes: PropTypes.object.isRequired,
  loading: PropTypes.bool
};

export default withStyles(styles, { name: 'NavChartOptions' })(NavChartOptions);



// WEBPACK FOOTER //
// ./src/components/nav/NavChartOptions.js